import { DomeComponent, React } from "@lexriver/dome"
import { Settings } from "../../Settings"
import { EnumCurrency } from "../enums/EnumCurrency"

interface Attrs{
    price?:number
    priceInDollar?:number
    discountPrice?:number
    discountPriceInDollar?:number
    discountBasePrice?:number
    hideEqualSignBeforeDollar?:boolean
}

export class Price extends DomeComponent<Attrs>{
    render() {
        const useDollarPrice = Settings.checkIfDomainIsShop() && this.attrs.priceInDollar
        const price = useDollarPrice ? this.attrs.priceInDollar : this.attrs.price
        const discountPrice = useDollarPrice ? this.attrs.discountPriceInDollar : this.attrs.discountPrice
        const currency = useDollarPrice ? EnumCurrency.USD : EnumCurrency.RUB

        if(price && discountPrice && discountPrice > 0 && discountPrice < price && (!this.attrs.discountBasePrice || this.attrs.discountBasePrice === this.attrs.price)){
            return <span>
                <span style={{textDecoration:'line-through'}}>{Settings.formatNumberToPrice(price, currency)}</span>&nbsp;
                <span style={{color:'#d70404'}}>{Settings.formatNumberToPrice(discountPrice, currency)}</span>
            </span>
        }
        if(price){
            return Settings.formatNumberToPrice(price, currency)
        }
        return <></>
    }
}